import { useSpinner } from "@components/SpinnerContext";
import { CardLinkTranslation } from "@models/card-link-translation.model";
import { SponsoredCardTranslation } from "@models/sponsored-card-translation-model";
import accomodationService from "@services/accomodation.service";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Page404 from '@pages/NotFoundPage';
import CardLink from "@components/CardLink";
import CardSponsored from "@components/CardSponsored";
import titleService from "@services/title.service";
import PageHeader from "@components/PageHeader";
import InputComponent from "@components/InputComponent";

type UnifiedItem = {
  id: string; // chiave univoca per React
  type: "sponsored" | "link";
  title: string; // required dal tuo InputComponent/formatText
  data: CardLinkTranslation | SponsoredCardTranslation; // oggetto originale
};

const LinksPage = () => {
  const { showSpinner, hideSpinner, loading } = useSpinner();
  const [isPageNotFound, setIsPageNotFound] = useState(false);
  const location = useLocation();

  const [cardLink, setCardLink] = useState<CardLinkTranslation[] | undefined>(undefined);
  const [pageTitle, setPageTitle] = useState("");

  const [mergedList, setMergedList] = useState<UnifiedItem[]>([]);
  const [filteredMergedList, setFilteredMergedList] = useState<UnifiedItem[]>([]);

  useEffect(() => {
    async function getLinkSponsoredData(id: number, qrCodeId: string) {
      try {
        showSpinner();
        const title = await titleService.getTitle(qrCodeId, id);
        setPageTitle(title);

        const linkResponse = await accomodationService.getCardLinkFromIdParent(id) ?? [];
          
        setCardLink(linkResponse);

        const merged: UnifiedItem[] = [

          // ...sponsoredResponse.map((sponsored, idx) => ({
          //   id: `s-${(sponsored as any).id ?? idx}`,
          //   type: "sponsored" as const,
          //   title: (sponsored as any).title ?? (sponsored as any).name ?? "",
          //   data: sponsored,
          // })),
          ...linkResponse.map((link, idx) => ({
            id: `l-${(link as any).id ?? idx}`,
            type: "link" as const,
            title: (link as any).title ?? (link as any).name ?? "",
            data: link,
          })),
        ];

        setMergedList(merged);
        setFilteredMergedList(merged);

      } catch (error) {
        setIsPageNotFound(true);
        console.error(error);
      } finally {
        hideSpinner();
      }
    }

    const parts = location.pathname.split("/").filter(Boolean);
    const qrCodeId = parts[0];
    const id = parts[parts.length - 2];

    getLinkSponsoredData(parseInt(id, 10), qrCodeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mx-3">
      <div className="sticky-top sticky-header border-bottom border-light">
        <PageHeader pageTitle={pageTitle} flagSearch={false} flag={false} />
        <div className="col-12">
          <InputComponent list={mergedList} setFilteredList={setFilteredMergedList} isAccomodation={false}/>
        </div>
      </div>
      {isPageNotFound ? (
        <Page404 />
      ) : (
        loading ? null : (
          <div className="container mt-4">
            <div className="row g-3 ">
              {filteredMergedList.map(item => (
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 d-flex align-items-stretch" key={item.id}>
                  {item.type === "sponsored" ? (
                    <CardSponsored sponsoredCardTranslation={item.data as SponsoredCardTranslation} />
                  ) : (
                    <div className="card-suggestion d-block h-100 w-100">
                      <CardLink sponsoredLinkTranslation={item.data as CardLinkTranslation} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default LinksPage;
